import script from "./Product.vue?vue&type=script&setup=true&lang=ts"
export * from "./Product.vue?vue&type=script&setup=true&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=166c5fd4&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166c5fd4"]])

export default __exports__